module.exports = __webpack_public_path__ + "static/media/icon_link.a893c77d.svg";